import { DataSourceMode, DataSourceModeChangeEvent } from "@mcleod/components";
import { AutogenLayoutMobileCommPerformanceData } from "./autogen/AutogenLayoutMobileCommPerformanceData";

export class MobileCommPerformanceData extends AutogenLayoutMobileCommPerformanceData {
    /**
     * Handles data source mode changes to show/hide the execute button.
     * Shows the execute button only when in search mode.
     * @param event The data source mode change event
     */
    sourceMobileCommPerformanceDataAfterModeChange(event: DataSourceModeChangeEvent) {
        this.dataheaderMobileCommPerformanceData.showExecute = (event.newMode === DataSourceMode.SEARCH);
    }
}
